import React from "react";
import { GradeLevelOverride, AssessmentProvider } from "Redux/Redux.props";

type providerSettingsProps = {
  detailsForMyPathMath: AssessmentProvider;
  detailsForMyPathReading: AssessmentProvider;
};

interface Props extends providerSettingsProps {}
function ProviderSettings(props: Props) {
  const { detailsForMyPathMath, detailsForMyPathReading } = props;

  const GetOverridesString = (overrides: GradeLevelOverride[]) => {
    var finalString = "";
    overrides.forEach((o) => {
      finalString += `Grade ${o.gradeLevel}: ${o.provider},`;
    });
    return finalString.slice(0, -1);
  };

  return (
    <>
      <div>
        <p className="mypathSettingTagName"> MyPath Math </p>

        <p className="settingstagvalue"> {detailsForMyPathMath ? "On" : "Off"} </p>
      </div>
      <div>
        <p className="mypathSettingTagName">MyPath Math Grade Level Override </p>

        <p className="settingstagvalue">
          {detailsForMyPathMath?.gradeLevelOverrides?.length > 0
            ? GetOverridesString(detailsForMyPathMath.gradeLevelOverrides)
            : "None"}
        </p>
      </div>
      <div>
        <p className="mypathSettingTagName"> MyPath Reading </p>

        <p className="settingstagvalue"> {detailsForMyPathReading ? "On" : "Off"} </p>
      </div>
      <div>
        <p className="mypathSettingTagName">MyPath Reading Grade Level Override </p>
        <p className="settingstagvalue">
          {detailsForMyPathReading?.gradeLevelOverrides?.length > 0
            ? GetOverridesString(detailsForMyPathReading.gradeLevelOverrides)
            : "None"}
        </p>
      </div>
    </>
  );
}

export default ProviderSettings;
